import { useState } from 'react';
import './../styles/Navbar.css';

const NAV_LINKS = [
  { label: 'About', href: 'https://www.zilliqa.com/about/' },
  { label: 'Roadmap', href: 'https://www.zilliqa.com/roadmap/' },
  { label: 'Ecosystem', href: 'https://www.zilliqa.com/ecosystem/' },
  { label: 'FAQ', href: 'https://www.zilliqa.com/faq/' },
  { label: 'Blog', href: 'https://blog.zilliqa.com/', external: true },
];

const SOCIALS = [
  { name: 'X', href: 'https://x.com/zilliqa' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/checkpoint/challengesV2' },
  { name: 'Instagram', href: 'https://www.instagram.com/zilliqa_official/' },
  { name: 'Discord', href: 'https://discord.com/invite/zilliqa' },
  { name: 'Telegram', href: 'https://t.me/zilliqachat' },
];

function LogoMark() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 6.5C2 5.11929 3.11929 4 4.5 4H20L4 21.5V25.5C4 26.8807 5.11929 28 6.5 28H23.5C24.8807 28 26 26.8807 26 25.5V21.5C26 20.1193 24.8807 19 23.5 19H8L24 1.5V4"
        stroke="white"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(0 -1)"
      />
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 17 17 7M17 7H9M17 7v8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function XIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.9 2H22l-7.6 8.7L23 22h-6.9l-5.4-6.9L4.4 22H1.3l8.1-9.3L1 2h7l4.9 6.3L18.9 2Zm-1.2 18h1.9L7.3 4H5.3l12.4 16Z" />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
      <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.1c.5-1 1.9-2 3.8-2 4.1 0 4.9 2.7 4.9 6.2V21h-4v-5.7c0-1.4 0-3.2-2-3.2s-2.3 1.5-2.3 3.1V21h-4V9Z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
    </svg>
  );
}

function DiscordIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M8.5 9.5c1.5-.7 3-.7 4.5 0M6 16c3.5 1.2 8.5 1.2 12 0M8 17.5c-3-1-5-2.7-5-5.5 0-3.2 1.7-6.3 4.3-7.5.6.7 1 1.4 1.3 2.1M16 17.5c3-1 5-2.7 5-5.5 0-3.2-1.7-6.3-4.3-7.5-.6.7-1 1.4-1.3 2.1"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="9" cy="12.5" r="1.1" fill="currentColor" />
      <circle cx="15" cy="12.5" r="1.1" fill="currentColor" />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 4 2.5 11.4c-1 .4-1 1.7.1 2l4.4 1.4 1.7 5.3c.3.9 1.4 1.1 2.1.4l2.4-2.3 4.5 3.3c.8.6 2 .2 2.2-.8L22.7 5.2c.2-1-.7-1.7-1.7-1.2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M8.9 14.8 18 7.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

const SOCIAL_ICON_MAP = {
  X: XIcon,
  LinkedIn: LinkedInIcon,
  Instagram: InstagramIcon,
  Discord: DiscordIcon,
  Telegram: TelegramIcon,
};

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar__inner">
        <a href="/" className="navbar__brand" onClick={() => setMenuOpen(false)}>
          <LogoMark />
          <span>ZILLIQA</span>
        </a>

        {/* Desktop links */}
        <nav className="navbar__links">
          {NAV_LINKS.map((link) => (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="navbar__actions">
          <a className="zq-btn zq-btn--outline zq-btn--sm" href="https://dev.zilliqa.com/zilliqa2/">
            Build
          </a>
          <a className="zq-btn zq-btn--solid zq-btn--sm" href="https://stake.zilliqa.com/">
            Earn
          </a>
        </div>

        {/* Mobile hamburger - collapses to a single dash when open */}
        <button
          type="button"
          className={`navbar__toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Full-screen mobile menu */}
      <div className={`navbar__mobile-panel ${menuOpen ? 'is-open' : ''}`}>
        <nav className="navbar__mobile-links">
          {NAV_LINKS.map((link) => (
            <a key={link.label} href={link.href} onClick={() => setMenuOpen(false)}>
              {link.label}
              {link.external && <ExternalIcon />}
            </a>
          ))}
        </nav>

        <div className="navbar__mobile-contact">
          <a className="navbar__mobile-email" href="mailto:enquiry@zilliqa.com">
            enquiry@zilliqa.com
          </a>
          <div className="navbar__mobile-socials">
            {SOCIALS.map((social) => {
              const Icon = SOCIAL_ICON_MAP[social.name];
              return (
                <a key={social.name} href={social.href} aria-label={social.name}>
                  <Icon />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </header>
  );
}